export const instrumentationReorderTypes = {
    GroupedMember: "GroupedMember",
    UngroupedMember: "UngroupedMember",
    Group: "Group"
};
